import LocalStorageService from '@/Services/LocalStorageService'

const LocalStorageModule = {
  namespaced: true,
  state: {
    service: null,
  	status: localStorage.getItem('local-storage-status') || '',
  	storage: JSON.parse(localStorage.getItem('local-storage'))
  },
  mutations: {
    initService (state, opt) {
      state.service = opt.service
    },
    setToState (state, key) {
      state.status = true
      state.storage = JSON.parse(localStorage.getItem(key))
    }
  },
  getters: {
    service: (state, getters) => (vm = null) => {
      return state.service ?? LocalStorageService.getInstance(vm)
    },
    hasStatus: (state) => () => {
      return !!state.status
    },
    get: (state) => (key) => {
      return state[key]
    },
    stepMenu (state, getters) {
      return getters.service().getStepMenuData
    },
    stepMenu2 (state, getters) {
      return getters.service().getStepMenuData2
    }
  },
  actions: {
    async init ({ commit, getters }) {
      await commit('initService', { service: LocalStorageService.getInstance(this._vm) })
      return false 
    },
    fetch ({ dispatch, commit, state, rootState, getters, rootGetters }, loclae = false) {
  		return new Promise((resolve, reject) => 
  			getters.service(this._vm)
  			.fetch({ locale: loclae ?? rootGetters.params.locale })
  			.then(
            response => {

            	localStorage.setItem('local-storage-status', true)
            	localStorage.setItem('local-storage', JSON.stringify(response.data))

            	commit('setToState', 'local-storage')
            	resolve(true)
		    }, 
		    response => {

		    	// localStorage.removeItem('token')
		    	// reject(response)
		    
		    })
  		)
  	}
  }
}

export default LocalStorageModule

